var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12" },
    _vm._l(_vm.options, function (option) {
      return _c(
        "div",
        {
          key: option.id,
          staticClass: "form-container fe-radio-form large-radio ml-5 px-0",
        },
        [
          _c(
            "div",
            {
              staticClass: "fe-option col-xs-12",
              class: option.multiLine ? "w-70 multi-line my-3 h-auto" : "",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.answer.secondOption,
                    expression: "answer.secondOption",
                  },
                ],
                attrs: {
                  id: "" + option.id,
                  type: "radio",
                  disabled: _vm.disabled,
                },
                domProps: {
                  value: option.value,
                  checked: _vm._q(_vm.answer.secondOption, option.value),
                },
                on: {
                  change: [
                    function ($event) {
                      return _vm.$set(_vm.answer, "secondOption", option.value)
                    },
                    _vm.handleChange,
                  ],
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "checkmark" }),
              _vm._v(" "),
              option.textAreaInsideLabel
                ? _c(
                    "label",
                    {
                      attrs: { for: "" + option.id },
                      on: {
                        click: function ($event) {
                          _vm.answer.secondOption = option.value
                        },
                        change: _vm.handleExplainChange,
                      },
                    },
                    [
                      _c("textarea", {
                        style: {
                          order: _vm.getOrder(option.textAreaInsideLabel),
                        },
                        attrs: {
                          id: option.id + "-textareaId",
                          rows: _vm.rows,
                          cols: _vm.cols,
                        },
                        domProps: { value: _vm.answer.secondOptionText },
                        on: { change: _vm.handleExplainChange },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "w-auto pl-0 pr-3",
                          class: {
                            "text-light":
                              _vm.answer.secondOption === option.value,
                          },
                          attrs: { for: option.id + "-textareaId" },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(option.text) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _c("label", { attrs: { for: "" + option.id } }, [
                    _vm._v("\n        " + _vm._s(option.text) + "\n      "),
                  ]),
            ]
          ),
          _vm._v(" "),
          option.comparison
            ? _c(
                "p",
                {
                  staticClass: "mt-3 text-uppercase bold",
                  class: { bold: option.boldComparison },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("global.words.or")) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          option.textExplain
            ? _c(
                "div",
                {
                  staticClass:
                    "form-group-material form-group-material-no-label",
                },
                [
                  _c(_vm.inputComponent(option.textExplainType), {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.answer.secondOption == option.value,
                        expression: "answer.secondOption == option.value",
                      },
                    ],
                    tag: "component",
                    staticClass: "mw-100",
                    attrs: {
                      title: option.textExplainLabel || "",
                      prompt: option.textExplainLabel || "",
                      value: _vm.answer.text,
                    },
                    on: { input: _vm.handleExplainChange },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }